// import hamburgerButton from './js/button-hamburger';
import "./js/mobile-menu";
import "./js/accordion";
import "./js/collapsible-menu";
import "./js/header-menu";
import "./js/header-shadow-after-scroll";
import "./js/products-buttons-handler";
import "./js/language-toggler";
